import { fontStyle } from "Constants";

export const styles = {
  allSchoolsFeedListStyles: {
    parentStyle: {
      gridTemplateColumns: "320px repeat(8,1fr)",
      justifyItems: "center",
    },
  },
  transitionFeedListStyles: {
    parentStyle: {
      gridTemplateColumns: "400px repeat(6,1fr)",
      justifyItems: "center",
    },
  },
  countStyle: {
    ...fontStyle.demiBold,
  },
  labelStyle: {
    ...fontStyle.demiBold,
  },
};
